(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/team-page/assets/javascripts/team-corrects-and-rank.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/team-page/assets/javascripts/team-corrects-and-rank.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const {
  Shield
} = svs.components.lbUi.shield;
const {
  StepIndicator
} = svs.components.marketplaceShared.stepIndicator;
const {
  getTeamStatus
} = svs.components.marketplaceCompetition.services.helpers.teamHelper;
const {
  useCompetitionId,
  useDrawsViaContext
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useCompetition,
  useCompetitionBranding
} = svs.components.marketplaceCompetition.services.hooks;
const EMPTY_CORRECTS = '?';
const EMPTY_POSITION = '...';
const TeamCorrectsAndRank = _ref => {
  var _teamResult$data, _teamResult$data2, _team$data, _teamResult$data7;
  let {
    isSmall,
    team,
    teamResult
  } = _ref;
  const [activeStep, setActiveStep] = useState(undefined);
  const [correctCount, setCorrectCount] = useState((teamResult === null || teamResult === void 0 || (_teamResult$data = teamResult.data) === null || _teamResult$data === void 0 ? void 0 : _teamResult$data.correctCount) || EMPTY_CORRECTS);
  const [position, setPosition] = useState((teamResult === null || teamResult === void 0 || (_teamResult$data2 = teamResult.data) === null || _teamResult$data2 === void 0 || (_teamResult$data2 = _teamResult$data2.position) === null || _teamResult$data2 === void 0 ? void 0 : _teamResult$data2.current) || EMPTY_POSITION);
  const competitionId = useCompetitionId();
  const competition = useCompetition(competitionId);
  const competitionBranding = useCompetitionBranding(competition === null || competition === void 0 ? void 0 : competition.compType);
  const status = getTeamStatus({
    team: team.data,
    competition
  });
  const resultHeader = (_team$data = team.data) !== null && _team$data !== void 0 && _team$data.name ? "Resultat f\xF6r ".concat(team.data.name) : 'Lagets resultat';
  useEffect(() => {
    if (teamResult.data) {
      if (activeStep !== undefined) {
        var _teamResult$data3, _teamResult$data4;
        setCorrectCount((_teamResult$data3 = teamResult.data) === null || _teamResult$data3 === void 0 || (_teamResult$data3 = _teamResult$data3.drawResults[activeStep]) === null || _teamResult$data3 === void 0 ? void 0 : _teamResult$data3.correctCount);
        setPosition((_teamResult$data4 = teamResult.data) === null || _teamResult$data4 === void 0 || (_teamResult$data4 = _teamResult$data4.drawResults[activeStep]) === null || _teamResult$data4 === void 0 ? void 0 : _teamResult$data4.position);
      } else {
        var _teamResult$data5, _teamResult$data6;
        setCorrectCount((_teamResult$data5 = teamResult.data) === null || _teamResult$data5 === void 0 ? void 0 : _teamResult$data5.correctCount);
        setPosition((_teamResult$data6 = teamResult.data) === null || _teamResult$data6 === void 0 || (_teamResult$data6 = _teamResult$data6.position) === null || _teamResult$data6 === void 0 ? void 0 : _teamResult$data6.current);
      }
    } else {
      setCorrectCount(EMPTY_CORRECTS);
      setPosition(EMPTY_POSITION);
    }
  }, [activeStep, teamResult]);
  return React.createElement("div", {
    className: "team-page-part team-page-part-first"
  }, React.createElement("div", {
    className: "team-page-header"
  }, resultHeader), React.createElement("div", {
    className: "f-center team-page-status"
  }, status), React.createElement("div", {
    className: "team-page-stats"
  }, React.createElement("div", {
    className: "stats-box stats-box-left"
  }, React.createElement(Shield, {
    className: "shield-medium shield-".concat(competitionBranding),
    options: {
      hasShadow: true,
      hasHover: true
    }
  }, React.createElement("span", {
    className: "shield-value",
    "data-testid": "qa-shield-correct-count"
  }, correctCount), React.createElement("span", {
    className: "shield-unit"
  }, "r\xE4tt")), React.createElement("div", {
    className: "stats-box-label"
  }, activeStep === undefined ? 'Totalt' : "Omg\xE5ng ".concat(activeStep + 1))), React.createElement("div", {
    className: "stats-box stats-box-right"
  }, React.createElement("div", {
    className: "stats-box-value ".concat(competitionBranding),
    "data-testid": "qa-shield-rank"
  }, position), React.createElement("div", {
    className: "stats-box-label"
  }, "Placering"))), React.createElement("div", {
    className: "f-center margin-bottom-1 margin-top-1 margin-top-md-2"
  }, "Omg\xE5ngar"), React.createElement(StepIndicator, {
    branding: competitionBranding,
    daysPerStep: 7,
    handleClickByIndex: index => {
      const step = index === activeStep ? undefined : index;
      setActiveStep(step);
    },
    isInvertedButtons: isSmall,
    numberOfActiveSteps: teamResult === null || teamResult === void 0 || (_teamResult$data7 = teamResult.data) === null || _teamResult$data7 === void 0 ? void 0 : _teamResult$data7.drawResults.length,
    steps: [{
      label: '1'
    }, {
      label: '2'
    }, {
      label: '3'
    }, {
      label: '4'
    }, {
      label: '5'
    }, {
      label: '6'
    }]
  }));
};
setGlobal('svs.components.marketplaceCompetition.teamPage.TeamCorrectsAndRank', TeamCorrectsAndRank);

 })(window);